import React from "react";
import {
  GoogleMap,  
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import useExecuteContext from "../utils/hooks/executeContext";


const containerStyle = {
  width: "100%",
  height: "100%",
};

const MapComponent = ({ locationData, card }) => {
  const { currentLocation } = useExecuteContext();

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={{
        lat: currentLocation?.lat || 0,
        lng: currentLocation?.lng || 0,
      }}
      zoom={10}
    >
      {locationData?.map((location) => (
        <React.Fragment key={location?._id}>
          <Marker position={{ lat: location.lat, lng: location.lng }} />

          {/* Always Visible InfoWindow */}
          {card && location?._id === currentLocation?._id && (
            <InfoWindow position={{ lat: location.lat, lng: location.lng }}>
              <div
                style={{ textAlign: "center" }}
                className="location_card_view"
              >
                <h6 style={{ color: "#682f18" }}>{location?.location}</h6>
                <img
                  src={location?.img}
                  alt={location?.location}
                  style={{
                    height: "160px",
                    borderRadius: "8px",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  }}
                />
                <br />
                {location?.type === "Builder" && (
                  <a
                    href={`project/${location.slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="location_btn"
                  >
                    Know More
                  </a>
                )}
                <br />
                <a
                  href={`https://www.google.com/maps?q=${location?.lng},${location?.lat}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="location_btn mt-3"
                >
                  View Location
                </a>
              </div>
            </InfoWindow>
          )}
        </React.Fragment>
      ))}
    </GoogleMap>
  );
};

export default MapComponent;
